import { IWalletTokenData } from "../../types/wallet.type";
import { apiSlice } from "./apiSlice";

export const walletApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWalletSession: builder.mutation<IWalletTokenData, void>({
      query: (credentials) => ({
        url: "/wallet/auth/token",
        method: "post",
      }),
      transformResponse: (response: { data: IWalletTokenData }) =>
        response.data,
    }),
  }),
});

export const { useGetWalletSessionMutation } = walletApi;
